/**
 * Formats a German phone number into a structured format
 * @param phone - Phone number string (e.g., "+491234567890" or "491234567890")
 * @returns Formatted phone number (e.g., "+49 123 4567 890" or "49 123 4567 890")
 */
export const formatPhoneNumber = (phone: string): string => {
  const trimmed = phone.trim();
  const hasPlus = trimmed.startsWith("+");
  const digits = trimmed.replace(/\D/g, "");

  // Frankfurt (069): country 49 + area 69 + local number
  const isFrankfurt = digits.startsWith("4969");
  const formatted = isFrankfurt
    ? digits.replace(/(\d{2})(\d{2})(\d{4})(\d+)/, "$1 $2 $3 $4")
    : digits.replace(/(\d{2})(\d{3})(\d{4})(\d+)/, "$1 $2 $3 $4");

  return hasPlus ? `+${formatted}` : formatted;
};
